// extracted by mini-css-extract-plugin
module.exports = {"summaryPrice":"SummaryItem_summaryPrice__80uEk","summaryItemTitle":"SummaryItem_summaryItemTitle__xE26o","summaryItemPrice":"SummaryItem_summaryItemPrice__prKn2"};